/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { Breadcrumb, Button, Card, Input, message } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MinusOutlined, ReloadOutlined, EyeOutlined } from '@ant-design/icons';
import {
	deleteVehicleType,
	getAllVehicleTypePaged,
	getNightShiftByVehicleTypeId,
	getPeakSurchargeByVehicleTypeId,
} from '../../redux/vehicleTypeSlice';
import CustomTableComponentsPageable from '../Global/CustomTableComponentsPageable';
import { style } from '../../Styles';
import { FareSurchargeModal } from './FareSurchargeModal';
import DrawerVehicleType from './DrawerVehicleType';
import { getAllLocation } from '../../redux/locationSlice';
import ActionButton from '../Global/ActionsButton';
import ImageComponent from '../Global/ImageComponent/ImageComponent';
import { getVehicleTypeFiles } from '../../redux/fileSlice';
import { NIGHT_SHIFT, PEAK_SURCHARGE } from '../../Utils/Constants/utils';
// eslint-disable-next-line no-unused-vars

// todo implement location name when location management settled

const VehicleType = ({ role }) => {
	const { auth } = useSelector((state) => state.auth);
	const { Settings } = useSelector((state) => state.settings);

	const [search, setSearch] = useState('');
	const searchTimerRef = useRef(null);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(10);
	const [sortBy, setSortBy] = useState('vehicleType');
	const [sortDirection, setSortDirection] = useState('ASC');
	const dispatch = useDispatch();
	const [isMakingApiCall, setMakingApiCall] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [modalType, setModalType] = useState('');
	const [displayDrawer, setDisplayDrawer] = useState(false);
	const [vehicleType, setVehicleType] = useState(null);
	const [selectedRow, setSelectedRow] = useState('');
	const currencyRender = () => {
		return <span>{Settings?.settingsData?.currency || '€'}</span>;
	};
	const fetchData = () => {
		Promise.all([dispatch(getAllLocation()), dispatch(getVehicleTypeFiles())])
			.then(() => { })
			.catch(() => {
				message.error('Could not fetch locations');
				message.error('Could not fetch data');
			})
			.finally(() => { });
	};

	useEffect(() => {
		fetchData();
	}, []);

	const { Location } = useSelector((state) => state.locations);
	const locationArray = Object.values(Location.locationsList);

	const columns = [
		{
			title: 'Image',
			key: 'imageId',
			width: 100,
			render: (record) => {
				return record?.imageId ? (
					<ImageComponent imageId={record?.imageId} />
				) : (
					<MinusOutlined />
				);
			},
		},
		{
			title: 'Vehicle Type',
			key: 'vehicleType',
			width: 100,
			render: (record) => {
				return <span>{record.vehicleType}</span>;
			},
			sorter: true,
		},
		{
			title: 'Base Fare',
			key: 'baseFare',
			width: 100,
			render: (record) => {
				return (
					<div>
						{currencyRender()}
						{record.baseFare}
					</div>
				);
			},
			sorter: true,
		},
		{
			title: 'Price per KM',
			key: 'pricePerKm',
			width: 80,
			render: (record) => {
				return record.pricePerKm ? (
					<span>
						{currencyRender()}
						{record.pricePerKm}
					</span>
				) : (
					<MinusOutlined />
				);
			},
			sorter: true,
		},
		{
			title: 'Cancellation Charge',
			key: 'riderCancellationCharge',
			width: 120,
			render: (record) => {
				return (
					<span>
						{currencyRender()}
						{record.riderCancellationCharge}
					</span>
				);
			},
			sorter: true,
		},
		{
			title: 'Location',
			key: 'locationId',
			width: 90,
			render: (record) => {
				const location = locationArray.find((l) => l.id === record.locationId);

				return location ? <span>{location.locationName}</span> : <MinusOutlined />;
			},
			sorter: true,
		},
		{
			title: 'Available Seats',
			key: 'availableSeat',
			width: 100,
			render: (record) => {
				return <span>{record.availableSeat}</span>;
			},
			sorter: true,
		},
		{
			title: 'Peak Surcharge',
			key: 'peakSurcharge',
			render: (record) => {
				return (
					<span style={style.btnView}>
						<Button
							type='default'
							disabled={!record.peakSurcharge}
							style={{ height: 30 }}
							onClick={(event) => {
								setSelectedRow(record.id);
								loadPeakSurchargeData(event, record.id);
							}}>
							<EyeOutlined />
						</Button>
					</span>
				);
			},
			width: 100,
		},
		{
			title: 'Night Shift',
			key: 'nightShift',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						<Button
							type='default'
							disabled={!record.nightShift}
							style={{ height: 30 }}
							onClick={(event) => {
								setSelectedRow(record.id);
								loadNightShiftData(event, record.id);
							}}>
							<EyeOutlined />
						</Button>
					</span>
				);
			},
			width: 60,
		},
		// ? The vehicle type status is not used in the backend so we hide it for now
		/* {
			title: 'Status',
			key: 'active',
			render: (record) => {
				return (
					<span style={style.dataContainer}>
						{record.active ? (
							<div style={style.statusActif}>ACTIVE</div>
						) : (
							<div style={style.statusInactif}>INACTIVE</div>
						)}
					</span>
				);
			},
			width: 90,
		}, */
		{
			title: 'Actions',
			key: 'actions',
			width: 80,
			render: (text, record) => (
				<ActionButton
					record={record}
					onDelete={() => handleDlete(record?.id, () => { })}
					onEdit={() => handleSelectedVehicleType(record)}
					recordName={record.vehicleType}
				/>
			),

			disabled: !role?.includes('SUPER_ADMIN'),
		},
	];

	const handleDlete = (id, calbback) => {
		setMakingApiCall(true);
		dispatch(
			deleteVehicleType({
				vehicleTypeId: id,
			}),
		)
			.unwrap()
			.then(() => {
				calbback();
				message.success('Vehicle type deleted successfully');
			})
			.catch(() => { })
			.finally(() => {
				onCloseDrawer();
				setMakingApiCall(false);
			});
	};
	const { VehicleTypePaged, PeakSurchage, NightShift } = useSelector((state) => state.vehiclesType);

	const sortFieldMap = {
		locationId: 'locationName',
	};

	const handleTableChange = (_, __, sorter, extra) => {
		if (extra?.action !== 'sort') return;
		if (sorter.order) {
			const field = sorter.columnKey || sorter.field;
			setSortBy(sortFieldMap[field] || field);
			setSortDirection(sorter.order === 'ascend' ? 'ASC' : 'DESC');
		} else {
			setSortBy('vehicleType');
			setSortDirection('ASC');
		}
		setCurrentPage(1);
	};

	const loadPeakSurchargeData = (event, id) => {
		event.stopPropagation();
		setModalType(PEAK_SURCHARGE);
		makeApiCallPeakSurcharge(id);
	};
	const loadNightShiftData = (event, id) => {
		event.stopPropagation();
		setModalType(NIGHT_SHIFT);
		makeApiCallNightShift(id);
	};

	const makeApiCallPeakSurcharge = (id) => {
		const params = {
			vehicleTypeId: id,
		};
		dispatch(getPeakSurchargeByVehicleTypeId(params))
			.unwrap()
			.then()
			.catch(() => {
				message.error('Failed to load peak surcharge data');
			})
			.finally(() => {
				setIsModalOpen(true);
			});
	};
	const makeApiCallNightShift = (id) => {
		const params = {
			vehicleTypeId: id,
		};
		dispatch(getNightShiftByVehicleTypeId(params))
			.unwrap()
			.then()
			.catch(() => {
				message.error('Failed to load night shift data');
			})
			.finally(() => {
				setIsModalOpen(true);
			});
	};

	const handlePeakSurchageSwitch = (values, id) => {
		if (values && id) {
			setModalType(PEAK_SURCHARGE);
			setIsModalOpen(true);
			makeApiCallPeakSurcharge(id);
		} else if (values) {
			setModalType(PEAK_SURCHARGE);
			setIsModalOpen(true);
		}
	};

	const handleNightShiftSwitch = (values, id) => {
		if (values && id) {
			setModalType(NIGHT_SHIFT);
			setIsModalOpen(true);
			makeApiCallNightShift(id);
		} else if (values) {
			setModalType(NIGHT_SHIFT);
			setIsModalOpen(true);
		}
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		setSelectedRow(null);
	};

	const fetchAll = () => {
		setMakingApiCall(true);
		dispatch(getAllVehicleTypePaged({ page: currentPage - 1, size: pageSize, sortBy, sortDirection, search }))
			.unwrap()
			.then()
			.catch(() => {
				message.error('Failed to load vehicle type data');
			})
			.finally(() => {
				setMakingApiCall(false);
			});
	};
	useEffect(() => {
		fetchAll();
	}, [dispatch, auth.token, currentPage, pageSize, sortBy, sortDirection, search]);

	const handleSelectedVehicleType = (selectedVehicleType) => {
		setVehicleType(selectedVehicleType);
		setSelectedRow(selectedVehicleType.id);
		showDrawer();
	};
	const showDrawer = () => {
		setDisplayDrawer(true);
	};
	const onCloseDrawer = () => {
		setDisplayDrawer(false);
		setVehicleType(null);
	};

	const [fs, setFs] = useState([]);

	const handleFsChange = (newFs) => {
		setFs(newFs);
	};

	const vehicleTypeArray = VehicleTypePaged.list.map((item) => ({ ...item, key: item.id }));

	console.log(role?.includes('SUPER_ADMIN'));
	return (
		<Card
			style={{
				margin: 16,
				maxHeight: '90%', // Set maximum width
				height: 'auto', // Allow width to be dynamic
			}}>
			<div style={style.inlineContent}>
				<div
					style={{
						display: 'flex',
						alignContent: 'center',
						alignItems: 'center',
						float: 'left',
						marginBottom: 8,
					}}>
					<Breadcrumb
						style={{ margin: '0 3em 0 0', fontSize: '1.1em' }}
						items={[
							{
								title: 'Vehicles',
							},
							{
								title: 'Vehicle Types',
							},
						]}
					/>

					<Button
						type='default'
						size='small'
						// style={{ margin: '0 8px 8px 0' }}
						onClick={() => fetchAll()}>
						<ReloadOutlined />
					</Button>
				</div>

				<div
					style={{
						...style.inlineContent,
						float: 'right',
						marginBottom: 8,
					}}>
					<Input.Search
						placeholder='Search'
						style={{ margin: '0 8px 8px 0' }}
						onSearch={(val) => {
							if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
							setCurrentPage(1);
							setSearch(val);
						}}
						onChange={(e) => {
							const val = e.target.value;
							if (searchTimerRef.current) clearTimeout(searchTimerRef.current);
							searchTimerRef.current = setTimeout(() => {
								setCurrentPage(1);
								setSearch(val);
							}, 400);
						}}
					/>
					{role?.includes('SUPER_ADMIN') && (
						<Button
							type='default'
							style={{ float: 'right', marginBottom: 8 }}
							onClick={showDrawer}>
							Add Vehicle Type
						</Button>
					)}
				</div>
			</div>
			<CustomTableComponentsPageable
				isMakingApiCall={isMakingApiCall}
				columns={columns.filter((item) => {
					return !item.disabled;
				})}
				dataArray={vehicleTypeArray}
				handleSelectedRow={() => { }}
				handleDoubleClickRow={(record) =>
					role?.includes('SUPER_ADMIN') ? handleSelectedVehicleType(record) : {}
				}
				onTableChange={handleTableChange}
				scroll={{ x: 'max-content' }}
				pagination={{
					current: currentPage,
					pageSize,
					total: VehicleTypePaged.total || 0,
					onChange: (page, size) => {
						setCurrentPage(page);
						setPageSize(size);
					},
				}}
			/>
			{displayDrawer && (
				<DrawerVehicleType
					onClose={onCloseDrawer}
					vehicleTypeId={vehicleType?.id}
					handlePeakSurchageSwitch={handlePeakSurchageSwitch}
					handleNightShiftSwitch={handleNightShiftSwitch}
					fs={fs}
					handleDlete={handleDlete}
				/>
			)}
			<FareSurchargeModal
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
				type={modalType}
				vehicleTypeId={selectedRow}
				fareSurchargeData={
					selectedRow
						? modalType === PEAK_SURCHARGE
							? PeakSurchage.peakSurchageList
							: NightShift.nightShiftList
						: []
				}
				handleCancel={handleCancel}
				onFsChange={handleFsChange}
			/>
		</Card>
	);
};

export default VehicleType;
